import React, {useState, useRef, useEffect} from "react";
import {Row} from "antd";
import moment from "moment";
import ActionButtons from "./Components/ActionButtons";
import Filters from "./Components/Filters";
import {useFetch} from "../../hooks/useFetch";
import stores from "../../store/stores";
import DataTable from "./Components/DataTable";

const PaymentManagement = () => {
    const [firstRenderLoading, setFirstRenderLoading] = useState(true);
    const [selectedItem, setSelectedItem] = useState(null);
    const [showExcelUploadModal, setShowExcelUploadModal] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [reloadData, setReloadData] = useState({});
    const [recall, setRecall] = useState(true);
    const recallRef = useRef(recall);
    recallRef.current = recall;

    useEffect(() => {
        let timeout = null;
        timeout = setTimeout(async () => {
            if (Boolean(selectedItem?._id) && showExcelUploadModal) {
                setRecall(recallRef.current);
            } else {
                setRecall(!recallRef.current);
            }
        }, 15000);
        return () => clearTimeout(timeout);
    }, [recall]);

    const [filters, setFilters] = useState({
        city: undefined,
        approveStatus: "waitingApprove",
        period: "choose",
        startDate: moment().toDate(),
        endDate: moment()
            .add(1, "d")
            .toDate(),
        searchText: undefined
    });

    const [loading, data, setData, setLoading] = useFetch({
        fetchFn: stores.paymentPeriodStore.getPaymentPeriodList.bind(null, {}),
        dependencies: [filters, currentPage, reloadData, recall]
    });

    useEffect(() => {
        if (loading) {
            setFirstRenderLoading(false);
        }
        if (!firstRenderLoading) {
            setLoading(false);
        }
    }, [loading]);

    return (
        <div>
            {/* <Row gutter={[8, 8]}>
                <Filters
                    setCurrentPage={setCurrentPage}
                    setFilters={setFilters}
                    filters={filters}
                />
            </Row> */}
            <Row justify="end">
                <ActionButtons
                    {...filters}
                    skip={(currentPage - 1) * 10}
                    limit={10}
                    setReloadData={() => setReloadData(!reloadData)}
                />
            </Row>

            <Row>
                <DataTable
                    loading={firstRenderLoading || loading}
                    data={data?.result || []}
                    setData={setData}
                    dataCount={data?.result?.length || 0}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    setReloadData={() => setReloadData(!reloadData)}
                    selectedItem={selectedItem}
                    setSelectedItem={setSelectedItem}
                    showExcelUploadModal={showExcelUploadModal}
                    setShowExcelUploadModal={setShowExcelUploadModal}
                    setRecall={setRecall}
                />
            </Row>
        </div>
    );
};

export {PaymentManagement};
